import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={{ margin: "10px" }}>
      <h1>PRIVACY POLICY</h1>
      <p>Last updated April 10, 2023</p>
      <p>
        This privacy notice for Evolution Finance SRL ("Company," "we," "us," or
        "our"), describes how and why we might collect, store, use, and/or share
        ("process") your information when you use our services ("Services"),
        such as when you: Download and use our mobile application (Premium CMS),
        or any other application of ours that links to this privacy notice
        Engage with us in other related ways, including any sales, marketing, or
        events Questions or concerns? Reading this privacy notice will help you
        understand your privacy rights and choices. If you do not agree with our
        policies and practices, please do not use our Services. If you still
        have any questions or concerns, please contact us at
        catalin.manea@premium-security.ro.
      </p>
      <h2>1. WHAT INFORMATION DO WE COLLECT?</h2>
      <h2>Personal information you disclose to us</h2>
      <p>
        We collect personal information that you voluntarily provide to us when
        you register on the Services, express an interest in obtaining
        information about us or our products and Services, when you participate
        in activities on the Services, or otherwise when you contact us.
        Personal Information Provided by You. The personal information that we
        collect depends on the context of your interactions with us and the
        Services, the choices you make, and the products and features you use.
        The personal information we collect may include the following:
      </p>
      <ul>
        <li>names</li>
        <li>phone numbers</li>
        <li>email addresses</li>
        <li>mailing addresses</li>
        <li>job titles</li>
        <li>usernames</li>
        <li>passwords</li>
        <li>contact preferences</li>
      </ul>
      <p>
        <strong>Sensitive Information.</strong> We do not process sensitive
        information.
      </p>
      <p>
        <strong>Application Data.</strong> If you use our application(s), we
        also may collect the following information if you choose to provide us
        with access or permission:
      </p>
      <ul>
        <li>
          Geolocation Information. We may request access or permission to track
          location-based information from your mobile device, either
          continuously or while you are using our mobile application(s), to
          provide certain location-based services. If you wish to change our
          access or permissions, you may do so in your device's settings.
        </li>
        <li>
          Mobile Device Access. We may request access or permission to certain
          features from your mobile device, including your mobile device's
          sensors, camera, reminders, storage, nfc, and other features. If you
          wish to change our access or permissions, you may do so in your
          device's settings.
        </li>
        <li>
          Mobile Device Data. We automatically collect device information (such
          as your mobile device ID, model, and manufacturer), operating system,
          version information and system configuration information, device and
          application identification numbers, browser type and version, hardware
          model Internet service provider and/or mobile carrier, and Internet
          Protocol (IP) address (or proxy server). If you are using our
          application(s), we may also collect information about the phone
          network associated with your mobile device, your mobile device€™s
          operating system or platform, the type of mobile device you use, your
          mobile device€™s unique device ID, and information about the features
          of our application(s) you accessed.
        </li>
        <li>
          Push Notifications. We may request to send you push notifications
          regarding your account or certain features of the application(s). If
          you wish to opt out from receiving these types of communications, you
          may turn them off in your device's settings.
        </li>
      </ul>
      <p>
        This information is primarily needed to maintain the security and
        operation of our application(s), for troubleshooting, and for our
        internal analytics and reporting purposes.
      </p>
      <p>
        All personal information that you provide to us must be true, complete,
        and accurate, and you must notify us of any changes to such personal
        information.
      </p>
      <h2>Information automatically collected</h2>
      <p>
        We automatically collect certain information when you visit, use, or
        navigate the Services. This information does not reveal your specific
        identity (like your name or contact information) but may include device
        and usage information, such as your IP address, browser and device
        characteristics, operating system, language preferences, referring URLs,
        device name, country, location, information about how and when you use
        our Services, and other technical information. This information is
        primarily needed to maintain the security and operation of our Services,
        and for our internal analytics and reporting purposes.
      </p>
      <p>
        Like many businesses, we also collect information through cookies and
        similar technologies.
      </p>
      <p>The information we collect includes:</p>
      <ul>
        <li>
          Log and Usage Data. Log and usage data is service-related, diagnostic,
          usage, and performance information our servers automatically collect
          when you access or use our Services and which we record in log files.
          Depending on how you interact with us, this log data may include your
          IP address, device information, browser type, and settings and
          information about your activity in the Services (such as the date/time
          stamps associated with your usage, pages and files viewed, searches,
          and other actions you take such as which features you use), device
          event information (such as system activity, error reports (sometimes
          called "crash dumps"), and hardware settings).
        </li>
        <li>
          Device Data. We collect device data such as information about your
          computer, phone, tablet, or other device you use to access the
          Services. Depending on the device used, this device data may include
          information such as your IP address (or proxy server), device and
          application identification numbers, location, browser type, hardware
          model, Internet service provider and/or mobile carrier, operating
          system, and system configuration information.
        </li>
        <li>
          Location Data. We collect location data such as information about your
          device's location, which can be either precise or imprecise. How much
          information we collect depends on the type and settings of the device
          you use to access the Services. For example, we may use GPS and other
          technologies to collect geolocation data that tells us your current
          location (based on your IP address). You can opt out of allowing us to
          collect this information either by refusing access to the information
          or by disabling your Location setting on your device. However, if you
          choose to opt out, you may not be able to use certain aspects of the
          Services.
        </li>
      </ul>
      <h2>Information collected from other sources</h2>
      <p>
        In order to enhance our ability to provide relevant marketing, offers,
        and services to you and update our records, we may obtain information
        about you from other sources, such as public databases, joint marketing
        partners, affiliate programs, data providers, and from other third
        parties. This information includes mailing addresses, job titles, email
        addresses, phone numbers, intent data (or user behavior data), Internet
        Protocol (IP) addresses, social media profiles, social media URLs, and
        custom profiles, for purposes of targeted advertising and event
        promotion.
      </p>
      <h2>2. HOW DO WE PROCESS YOUR INFORMATION?</h2>
      <p>
        We process your personal information for a variety of reasons, depending
        on how you interact with our Services, including:
      </p>
      <ul>
        <li>
          <strong>
            To facilitate account creation and authentication and otherwise
            manage user accounts.
          </strong>
          We may process your information so you can create and log in to your
          account, as well as keep your account in working order.
        </li>
        <li>
          <strong>
            To deliver and facilitate delivery of services to the user.
          </strong>
          We may process your information to provide you with the requested
          service.
        </li>
        <li>
          <strong>To send administrative information to you.</strong> We may
          process your information to send you details about our products and
          services, changes to our terms and policies, and other similar
          information.
        </li>
        <li>
          <strong>To fulfill and manage your orders.</strong> We may process
          your information to fulfill and manage your orders, payments, returns,
          and exchanges made through the Services.
        </li>
        <li>
          <strong>To enable user-to-user communications.</strong> We may process
          your information if you choose to use any of our offerings that allow
          for communication with another user.
        </li>
        <li>
          <string>To save or protect an individual's vital interest.</string> We
          may process your information when necessary to save or protect an
          individual€™s vital interest, such as to prevent harm.
        </li>
      </ul>
      <h2>3. WHAT LEGAL BASES DO WE RELY ON TO PROCESS YOUR INFORMATION?</h2>
      <p>
        The General Data Protection Regulation (GDPR) and UK GDPR require us to
        explain the valid legal bases we rely on in order to process your
        personal information. As such, we may rely on the following legal bases
        to process your personal information:
      </p>
      <ul>
        <li>
          <strong>Consent.</strong> We may process your information if you have
          given us permission (i.e., consent) to use your personal information
          for a specific purpose. You can withdraw your consent at any time.{" "}
        </li>
        <li>
          <strong>Performance of a Contract.</strong> We may process your
          personal information when we believe it is necessary to fulfill our
          contractual obligations to you, including providing our Services or at
          your request prior to entering into a contract with you.
        </li>
        <li>
          <strong>Legal Obligations.</strong> We may process your information
          where we believe it is necessary for compliance with our legal
          obligations, such as to cooperate with a law enforcement body or
          regulatory agency, exercise or defend our legal rights, or disclose
          your information as evidence in litigation in which we are involved.
        </li>
        <li>
          <strong>Vital Interests.</strong> We may process your information
          where we believe it is necessary to protect your vital interests or
          the vital interests of a third party, such as situations involving
          potential threats to the safety of any person.
        </li>
      </ul>
      <h2>4. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?</h2>
      <p>
        We may need to share your personal information in the following
        situations:
      </p>
      <ul>
        <li>
          <strong>Business Transfers.</strong> We may share or transfer your
          information in connection with, or during negotiations of, any merger,
          sale of company assets, financing, or acquisition of all or a portion
          of our business to another company.
        </li>
        <li>
          <strong>Affiliates.</strong> We may share your information with our
          affiliates, in which case we will require those affiliates to honor
          this privacy notice. Affiliates include our parent company and any
          subsidiaries, joint venture partners, or other companies that we
          control or that are under common control with us.
        </li>
        <li>
          <strong>Business Partners.</strong> We may share your information with
          our business partners to offer you certain products, services, or
          promotions.
        </li>
      </ul>
      <h2>5. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?</h2>
      <p>
        We may use cookies and similar tracking technologies (like web beacons
        and pixels) to access or store information. Specific information about
        how we use such technologies and how you can refuse certain cookies is
        set out in our Cookie Notice.
      </p>
      <h2>6. HOW LONG DO WE KEEP YOUR INFORMATION?</h2>
      <p>
        We will only keep your personal information for as long as it is
        necessary for the purposes set out in this privacy notice, unless a
        longer retention period is required or permitted by law (such as tax,
        accounting, or other legal requirements). No purpose in this notice will
        require us keeping your personal information for longer than the period
        of time in which users have an account with us.
      </p>
      <p>
        When we have no ongoing legitimate business need to process your
        personal information, we will either delete or anonymize such
        information, or, if this is not possible (for example, because your
        personal information has been stored in backup archives), then we will
        securely store your personal information and isolate it from any further
        processing until deletion is possible.
      </p>
      <h2>7. HOW DO WE KEEP YOUR INFORMATION SAFE?</h2>
      <p>
        We have implemented appropriate and reasonable technical and
        organizational security measures designed to protect the security of any
        personal information we process. However, despite our safeguards and
        efforts to secure your information, no electronic transmission over the
        Internet or information storage technology can be guaranteed to be 100%
        secure, so we cannot promise or guarantee that hackers, cybercriminals,
        or other unauthorized third parties will not be able to defeat our
        security and improperly collect, access, steal, or modify your
        information. Although we will do our best to protect your personal
        information, transmission of personal information to and from our
        Services is at your own risk. You should only access the Services within
        a secure environment.
      </p>
      <h2>8. DO WE COLLECT INFORMATION FROM MINORS?</h2>
      <p>
        We do not knowingly solicit data from or market to children under 18
        years of age. By using the Services, you represent that you are at least
        18 or that you are the parent or guardian of such a minor and consent to
        such minor dependent€™s use of the Services. If we learn that personal
        information from users less than 18 years of age has been collected, we
        will deactivate the account and take reasonable measures to promptly
        delete such data from our records. If you become aware of any data we
        may have collected from children under age 18, please contact us at
        catalin.manea@premium-security.ro.
      </p>
      <h2>9. WHAT ARE YOUR PRIVACY RIGHTS?</h2>
      <p>
        In some regions (like the EEA and UK), you have certain rights under
        applicable data protection laws. These may include the right (i) to
        request access and obtain a copy of your personal information, (ii) to
        request rectification or erasure; (iii) to restrict the processing of
        your personal information; and (iv) if applicable, to data portability.
        In certain circumstances, you may also have the right to object to the
        processing of your personal information. You can make such a request by
        contacting us by using the contact details provided in the section "HOW
        CAN YOU CONTACT US ABOUT THIS NOTICE?" below.
      </p>
      <p>
        We will consider and act upon any request in accordance with applicable
        data protection laws.
      </p>
      <p>
        If you are located in the EEA or UK and you believe we are unlawfully
        processing your personal information, you also have the right to
        complain to your Member State data protection authority or UK data
        protection authority.
      </p>
      <p>
        If you are located in Switzerland, you may contact the Federal Data
        Protection and Information Commissioner.
      </p>
      <p>
        Withdrawing your consent: If we are relying on your consent to process
        your personal information, you have the right to withdraw your consent
        at any time. You can withdraw your consent at any time by contacting us
        by using the contact details provided in the section "HOW CAN YOU
        CONTACT US ABOUT THIS NOTICE?" below.
      </p>
      <p>
        However, please note that this will not affect the lawfulness of the
        processing before its withdrawal nor, will it affect the processing of
        your personal information conducted in reliance on lawful processing
        grounds other than consent.
      </p>
      <h2>Account Information</h2>
      <p>
        If you would at any time like to review or change the information in
        your account or terminate your account, you can contact us using the
        contact information provided.
      </p>
      <p>
        Upon your request to terminate your account, we will deactivate or
        delete your account and information from our active databases. However,
        we may retain some information in our files to prevent fraud,
        troubleshoot problems, assist with any investigations, enforce our legal
        terms and/or comply with applicable legal requirements.
      </p>
      <p>
        Cookies and similar technologies: Most Web browsers are set to accept
        cookies by default. If you prefer, you can usually choose to set your
        browser to remove cookies and to reject cookies. If you choose to remove
        cookies or reject cookies, this could affect certain features or
        services of our Services. You may also opt out of interest-based
        advertising by advertisers on our Services.
      </p>
      <p>
        If you have questions or comments about your privacy rights, you may
        email us at catalin.manea@premium-security.ro.
      </p>
      <h2>10. CONTROLS FOR DO-NOT-TRACK FEATURES</h2>
      <p>
        Most web browsers and some mobile operating systems and mobile
        applications include a Do-Not-Track ("DNT") feature or setting you can
        activate to signal your privacy preference not to have data about your
        online browsing activities monitored and collected. At this stage no
        uniform technology standard for recognizing and implementing DNT signals
        has been finalized. As such, we do not currently respond to DNT browser
        signals or any other mechanism that automatically communicates your
        choice not to be tracked online. If a standard for online tracking is
        adopted that we must follow in the future, we will inform you about that
        practice in a revised version of this privacy notice.
      </p>
      <h2>11. DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</h2>
      <p>
        California Civil Code Section 1798.83, also known as the "Shine The
        Light" law, permits our users who are California residents to request
        and obtain from us, once a year and free of charge, information about
        categories of personal information (if any) we disclosed to third
        parties for direct marketing purposes and the names and addresses of all
        third parties with which we shared personal information in the
        immediately preceding calendar year. If you are a California resident
        and would like to make such a request, please submit your request in
        writing to us using the contact information provided below.
      </p>
      <p>
        If you are under 18 years of age, reside in California, and have a
        registered account with Services, you have the right to request removal
        of unwanted data that you publicly post on the Services. To request
        removal of such data, please contact us using the contact information
        provided below and include the email address associated with your
        account and a statement that you reside in California. We will make sure
        the data is not publicly displayed on the Services, but please be aware
        that the data may not be completely or comprehensively removed from all
        our systems (e.g., backups, etc.).
      </p>
      <h2>12. DO WE MAKE UPDATES TO THIS NOTICE?</h2>
      <p>
        We may update this privacy notice from time to time. The updated version
        will be indicated by an updated "Revised" date and the updated version
        will be effective as soon as it is accessible. If we make material
        changes to this privacy notice, we may notify you either by prominently
        posting a notice of such changes or by directly sending you a
        notification. We encourage you to review this privacy notice frequently
        to be informed of how we are protecting your information.
      </p>
      <h2>13. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</h2>
      <p>
        If you have questions or comments about this notice, you may email us at
        catalin.manea@premium-security.ro or by post to: Evolution Finance SRL
        BUCURESTI, SECTORUL 3, STRADA GHEORGHE PETRASCU, NR 7, CAM 1, ETAJ 1
        __________ Romania
      </p>
      <h2>
        14. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?
      </h2>
      <p>
        Based on the applicable laws of your country, you may have the right to
        request access to the personal information we collect from you, change
        that information, or delete it. To request to review, update, or delete
        your personal information, please fill out and submit a request at
        catalin.manea@premium-security.ro
      </p>
    </div>
  );
};

export default PrivacyPolicy;
